import { fromPairs, keyBy } from 'lodash';
import { Empty, Loaded, Loading, Refreshing } from 'stores/core';
const EMPTY = {
    byId: {},
    ids: Empty()
};
const load = ()=>({ byId, ids })=>({
            byId,
            ids: ids[0] === 'refreshing' || ids[0] === 'loading' ? ids : ids[0] === 'loaded' ? Refreshing(ids) : Loading()
        });
const putAll = (teams)=>()=>{
        const ids = teams.map(({ teamId })=>teamId);
        const lookup = keyBy(teams, 'teamId');
        return {
            byId: fromPairs(ids.map((id)=>[
                    id,
                    lookup[id]
                ])),
            ids: Loaded(ids)
        };
    };
const loaded = ({ ids })=>ids[0] === 'loaded';
const toList = ({ ids: [, teams = []], byId })=>teams.map((x)=>byId[x]).filter(Boolean);
const ofId = ([, teamId])=>({ byId })=>byId[teamId];
const add = (team)=>({ ids, byId })=>({
            byId: {
                ...byId,
                [team.teamId]: team
            },
            ids: Loaded(ids[1] ? [
                ...ids[1],
                team.teamId
            ] : [])
        });
const remove = (teamId)=>({ ids, byId })=>{
        const { [teamId]: deletedTeam, ...newById } = byId;
        return {
            byId: {
                ...newById
            },
            ids: Loaded(ids[1] ? [
                ...ids[1].filter((_id)=>_id !== teamId)
            ] : [])
        };
    };
const update = (team)=>({ ids, byId })=>({
            ids,
            byId: {
                ...byId,
                [team.teamId]: {
                    ...byId[team.teamId],
                    ...team
                }
            }
        });
export const TeamsStore = {
    empty: ()=>EMPTY,
    load,
    putAll,
    loaded,
    toList,
    ofId,
    add,
    remove,
    update
};
